export default {
    locations: {
        header: 'Locations',
        viewAll: 'See all',
        noLocations: 'No locations',
        allLocations: 'All locations',
    },
    jobModule: {
        header: 'Top positions',
        viewAllJobs: 'View all jobs from {companyName}',
        noPositions:
            '{companyName} currently does not have any open positions at Highered.',
        defaultLabel: 'Open positions',
    },
    videos: {
        header: 'Videos',
        noVideos: 'No videos',
        noMoreVideos: 'No more videos',
        moreVideosFrom: 'More videos from {companyName}',
    },
    articles: {
        header: 'Articles',
        noArticles: 'No articles',
        noMoreArticles: 'No more articles',
        moreArticlesFrom: 'More articles from {companyName}',
    },
};
